export function getAuthorSlug(author: { id?: string; name?: string } | null | undefined): string {
  const baseName = author?.name?.trim() || '';
  if (!baseName) {
    return author?.id ? `author-${author.id}` : 'author';
  }

  const slug = baseName
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return slug || `author-${author?.id || 'profile'}`;
}
